"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadyOverlay = ReadyOverlay;
const React = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const BalanceIcon_1 = require("~/components/ui/icon/BalanceIcon");
const LevelIcon_1 = require("~/components/ui/icon/LevelIcon");
const CloneChip_1 = require("~/components/ui/player/CloneChip");
const PositionChip_1 = require("~/components/ui/player/PositionChip");
const plugins_1 = require("~/plugins");
const players_1 = require("~/store/game/players");
const useStyles_1 = require("~/useStyles");
const models_1 = require("@creature-chess/models");
const player_1 = require("../../../ui/player");
const playerList_1 = require("../../playerList");
const boardOverlay_1 = require("./boardOverlay");
const quickChat_1 = require("./quickChat");
const useStyles = (0, useStyles_1.createUseThemeStyles)((theme) => ({
    root: {
        "display": "flex",
        "flexDirection": "column",
        "justifyContent": "center",
        "width": "100%",
        "gap": "16px",
        "@media (orientation: portrait) and (min-width: 431px)": {
            gap: "32px",
        },
    },
    wrapper: {
        "textAlign": "center",
        "flex": 1,
        "display": "flex",
        "flexDirection": "column",
        "justifyContent": "center",
        "background": "#566c86",
        "border": "2px solid #b13e53",
        "fontFamily": theme.typography.primary,
        "@media (orientation: portrait) and (min-width: 431px)": {
            padding: "8px",
        },
    },
    vsHeader: {
        "borderTop": "2px solid #b13e53",
        "borderBottom": "2px solid #b13e53",
        "& > h2": {
            margin: 0,
        },
    },
    badges: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        boxSizing: "border-box",
        alignItems: "center",
    },
    cloneTag: {
        background: "#333333",
        marginLeft: "0.5em",
        padding: "0 0.5em",
        fontStyle: "italic",
    },
    healthbar: {
        margin: 0,
    },
    playerDetails: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        flex: 2,
        gap: "4px",
    },
    playerAvatar: {
        flex: 1,
    },
    player: {
        "display": "flex",
        "flexDirection": "row",
        "padding": "8px",
        "@media (orientation: portrait) and (max-width: 430px)": {
            padding: "4px",
        },
    },
    nameWrapper: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "8px",
    },
    playerName: {
        fontSize: "12px",
    },
    tags: {
        display: "flex",
        flexDirection: "row",
        gap: "4px",
    },
}));
function ReadyOverlay() {
    var _a, _b, _c, _d;
    const styles = useStyles();
    const inReadyPhase = (0, react_redux_1.useSelector)((state) => state.game.roundInfo.phase === models_1.GamePhase.READY);
    const localPlayer = (0, players_1.useLocalPlayer)();
    const opponent = (0, players_1.useOpponentPlayer)();
    const localRank = (0, players_1.usePlayerRank)((_a = localPlayer === null || localPlayer === void 0 ? void 0 : localPlayer.id) !== null && _a !== void 0 ? _a : "");
    const opponentRank = (0, players_1.usePlayerRank)((_b = opponent === null || opponent === void 0 ? void 0 : opponent.id) !== null && _b !== void 0 ? _b : "");
    const spectatingPlayer = (0, react_redux_1.useSelector)((state) => state.game.spectating.id !== null);
    if (!localPlayer || !opponent || !inReadyPhase || spectatingPlayer) {
        return null;
    }
    const opponentIsClone = localPlayer.opponentIsClone;
    return (React.createElement(boardOverlay_1.BoardOverlay, null,
        React.createElement("div", { className: styles.root },
            React.createElement(plugins_1.Region, { cls: "overlay-content", id: "overlay.content", ctx: { localPlayerId: localPlayer.id } },
                React.createElement("div", { className: styles.wrapper },
                    React.createElement("div", { className: styles.player },
                        React.createElement("div", { className: styles.playerDetails },
                            React.createElement("div", { className: styles.nameWrapper },
                                React.createElement("span", { className: styles.playerName }, localPlayer.name),
                                React.createElement(PositionChip_1.PositionChip, { position: localRank })),
                            React.createElement(player_1.Title, { title: ((_c = localPlayer.profile) === null || _c === void 0 ? void 0 : _c.title) || null }),
                            React.createElement(player_1.PlayerHealthbar, { health: localPlayer.health }),
                            React.createElement("div", { className: styles.badges },
                                React.createElement(playerList_1.StreakIndicator, { type: localPlayer.streakType, amount: localPlayer.streakAmount }),
                                React.createElement(BalanceIcon_1.BalanceIcon, { amount: localPlayer.money }),
                                React.createElement(LevelIcon_1.LevelIcon, { amount: localPlayer.level }))),
                        React.createElement("div", { className: styles.playerAvatar },
                            React.createElement(plugins_1.Region, { cls: "player-avatar", id: "player.avatar.local", ctx: { playerId: localPlayer.id } },
                                React.createElement(player_1.PlayerAvatar, { player: localPlayer })),
                            React.createElement(quickChat_1.QuickChatBox, { playerId: localPlayer.id }))),
                    React.createElement("div", { className: styles.vsHeader }, "vs."),
                    React.createElement("div", { className: styles.player },
                        React.createElement("div", { className: styles.playerAvatar },
                            React.createElement(plugins_1.Region, { cls: "player-avatar", id: "player.avatar.opponent", ctx: { playerId: opponent.id } },
                                React.createElement(player_1.PlayerAvatar, { player: opponent })),
                            React.createElement(quickChat_1.QuickChatBox, { playerId: opponent.id })),
                        React.createElement("div", { className: styles.playerDetails },
                            React.createElement("div", { className: styles.nameWrapper },
                                React.createElement("span", { className: styles.playerName }, opponent.name),
                                React.createElement("div", { className: styles.tags },
                                    React.createElement(PositionChip_1.PositionChip, { position: opponentRank }),
                                    opponentIsClone && React.createElement(CloneChip_1.CloneChip, null))),
                            React.createElement(player_1.Title, { title: ((_d = opponent.profile) === null || _d === void 0 ? void 0 : _d.title) || null }),
                            React.createElement(player_1.PlayerHealthbar, { health: opponent.health }),
                            React.createElement("div", { className: styles.badges },
                                React.createElement(playerList_1.StreakIndicator, { type: opponent.streakType, amount: opponent.streakAmount }),
                                React.createElement(BalanceIcon_1.BalanceIcon, { amount: opponent.money }),
                                React.createElement(LevelIcon_1.LevelIcon, { amount: opponent.level })))))),
            React.createElement(quickChat_1.QuickChatButtonArray, { playerId: localPlayer.id }))));
}
